﻿/* ============================================
   HN PDP Main
   - Thumbnail rail â†’ swap active media in stage
   - Variant change â†’ swap to variant's featured media
   - Sticky ATC bar reveals when the in-page buy
     column scrolls out of view
   No framework. Idempotent: safe to run twice
   (re-binds use the same listener function refs).
   ============================================ */

(function () {
  'use strict';

  var MAX_PRODUCT_QTY = 30;

  /* ---------- Gallery ---------- */

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.hnPdpGalleryReady === '1') return;
    gallery.dataset.hnPdpGalleryReady = '1';

    var thumbs = gallery.querySelectorAll('[data-hn-pdp-thumb]');
    var media = gallery.querySelectorAll('[data-hn-pdp-media]');

    /* Two independent concerns: what's COMMITTED (the last clicked
       thumb â€” owns the red border, and is what we restore to on hover
       end) and what's DISPLAYED (which stage image is visible right
       now â€” can be the committed image OR a hover preview). */
    var committedId = thumbs[0] ? thumbs[0].dataset.mediaId : null;

    function showStage(mediaId) {
      if (!mediaId) return;
      media.forEach(function (m) {
        m.classList.toggle('is-active', m.dataset.mediaId === mediaId);
      });
    }

    function markThumbSelected(mediaId) {
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === mediaId;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    /* Commit a new selection. Used by click and by external callers
       (variant change). Updates the committed id, the thumb border,
       and the stage image together. Also keeps the active thumb in
       view within the rail (matters after swipe-driven changes).
       Pass `direction = 'next'` or `'prev'` to play a slide animation
       (used for swipe navigation). Without direction, the swap is
       instant via showStage (no animation overhead for clicks/hovers
       /variant changes). */
    function commit(mediaId, direction) {
      if (!mediaId) return;
      var exists = false;
      for (var i = 0; i < media.length; i++) {
        if (media[i].dataset.mediaId === mediaId) {
          exists = true;
          break;
        }
      }
      if (!exists) return;
      var previousId = committedId;
      committedId = mediaId;
      markThumbSelected(mediaId);
      if (direction && previousId && previousId !== mediaId) {
        slideTo(previousId, mediaId, direction);
      } else {
        showStage(mediaId);
      }
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].dataset.mediaId === mediaId && thumbs[i].scrollIntoView) {
          thumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          break;
        }
      }
    }

    /* Animate the swap between two media elements. The outgoing media
       slides off in `direction`, the incoming media slides in from the
       opposite side. Cleans up transient animation classes after the
       animation finishes so subsequent showStage calls behave normally. */
    function slideTo(fromId, toId, direction) {
      var fromEl = null;
      var toEl = null;
      for (var i = 0; i < media.length; i++) {
        if (media[i].dataset.mediaId === fromId) fromEl = media[i];
        if (media[i].dataset.mediaId === toId) toEl = media[i];
      }
      if (!fromEl || !toEl) {
        showStage(toId);
        return;
      }

      /* Clear stale animation classes from any prior in-flight swap */
      media.forEach(function (m) {
        m.classList.remove(
          'is-entering-right', 'is-entering-left',
          'is-leaving-left', 'is-leaving-right'
        );
      });

      var enterClass, leaveClass;
      if (direction === 'next') {
        /* Swipe-left â†’ next image. Old slides off to the LEFT, new
           comes in from the RIGHT. */
        enterClass = 'is-entering-right';
        leaveClass = 'is-leaving-left';
      } else {
        enterClass = 'is-entering-left';
        leaveClass = 'is-leaving-right';
      }

      /* Activate the incoming media so it's visible during the slide.
         Add the animation classes on the same frame so both elements
         transition together. */
      toEl.classList.add('is-active', enterClass);
      fromEl.classList.add(leaveClass);

      var cleanup = function () {
        fromEl.classList.remove('is-active', leaveClass);
        toEl.classList.remove(enterClass);
        fromEl.removeEventListener('animationend', cleanup);
      };
      fromEl.addEventListener('animationend', cleanup);
      /* Safety net in case animationend doesn't fire (e.g., reduced
         motion media query removes the animation entirely). */
      setTimeout(cleanup, 400);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { commit(t.dataset.mediaId); });

      /* Pointer hover preview on real-cursor devices only. Avoids
         touch-tap flicker (mouseenter fires on first tap on iOS). */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        /* mouseenter: preview hovered image WITHOUT changing committed
           selection. The committed thumb keeps its red border so the
           user always knows what they picked. */
        t.addEventListener('mouseenter', function () { showStage(t.dataset.mediaId); });
        /* mouseleave: restore the committed image. Fires when the cursor
           leaves the current thumb â€” including when it moves to another
           thumb (that thumb's mouseenter fires after, replacing the
           restore with its own preview). */
        t.addEventListener('mouseleave', function () { showStage(committedId); });
      }
    });

    /* Expose the commit fn so variant-change can drive the gallery
       as a full selection (not a transient preview). */
    gallery.hnPdpActivate = commit;

    /* Touch swipe on the stage â€” drag left to advance to the next
       image, drag right for the previous. Wraps around. Filters out
       vertical scrolls so the page can still scroll naturally if the
       finger moves mostly down. */
    var stage = gallery.querySelector('.hn-pdp__stage');
    if (stage && 'ontouchstart' in window) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var touchDeltaY = 0;
      var touchTracking = false;

      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        touchDeltaY = 0;
        touchTracking = true;
      }, { passive: true });

      stage.addEventListener('touchmove', function (e) {
        if (!touchTracking || e.touches.length !== 1) return;
        touchDeltaX = e.touches[0].clientX - touchStartX;
        touchDeltaY = e.touches[0].clientY - touchStartY;
      }, { passive: true });

      stage.addEventListener('touchend', function () {
        if (!touchTracking) return;
        touchTracking = false;
        /* Require a real horizontal gesture (>= 40px) AND that the
           horizontal motion dominates the vertical â€” otherwise we'd
           hijack scrolls that drift sideways. */
        if (Math.abs(touchDeltaX) < 40) return;
        if (Math.abs(touchDeltaY) > Math.abs(touchDeltaX)) return;

        var currentIdx = -1;
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].dataset.mediaId === committedId) {
            currentIdx = i;
            break;
          }
        }
        if (currentIdx === -1) return;

        var nextIdx, swipeDir;
        if (touchDeltaX < 0) {
          /* Swipe LEFT â†’ advance to next image */
          nextIdx = (currentIdx + 1) % thumbs.length;
          swipeDir = 'next';
        } else {
          /* Swipe RIGHT â†’ previous image */
          nextIdx = (currentIdx - 1 + thumbs.length) % thumbs.length;
          swipeDir = 'prev';
        }
        commit(thumbs[nextIdx].dataset.mediaId, swipeDir);
      });
    }

    /* Mobile-only: fade affordances at the top and bottom of the
       vertical thumb rail to signal more thumbs above/below the
       visible area. Bound to scroll + resize so the indicators stay
       accurate as the user scrolls the rail or rotates the device.
       Desktop has no rail scroll (horizontal-ish layout doesn't apply
       here), so we clear the data-attrs above 750px. */
    var thumbsEl = gallery.querySelector('.hn-pdp__thumbs');
    if (thumbsEl) {
      var setAttr = function (name, on) {
        if (on) gallery.setAttribute(name, '');
        else gallery.removeAttribute(name);
      };
      var updateThumbFade = function () {
        var isDesktop = window.matchMedia('(min-width: 750px)').matches;
        if (isDesktop) {
          /* Desktop: row scrolls horizontally â†’ fade on left/right */
          var left = thumbsEl.scrollLeft;
          var visibleW = thumbsEl.clientWidth;
          var totalW = thumbsEl.scrollWidth;
          setAttr('data-thumb-overflow-left', left > 4);
          setAttr('data-thumb-overflow-right', left + visibleW < totalW - 4);
          setAttr('data-thumb-overflow-top', false);
          setAttr('data-thumb-overflow-bottom', false);
        } else {
          /* Mobile: column scrolls vertically â†’ fade on top/bottom */
          var top = thumbsEl.scrollTop;
          var visibleH = thumbsEl.clientHeight;
          var totalH = thumbsEl.scrollHeight;
          setAttr('data-thumb-overflow-top', top > 4);
          setAttr('data-thumb-overflow-bottom', top + visibleH < totalH - 4);
          setAttr('data-thumb-overflow-left', false);
          setAttr('data-thumb-overflow-right', false);
        }
      };
      thumbsEl.addEventListener('scroll', updateThumbFade, { passive: true });
      window.addEventListener('resize', updateThumbFade);
      /* Run once after layout settles so we get the right scrollHeight */
      requestAnimationFrame(updateThumbFade);

      /* Desktop: convert vertical mousewheel input into horizontal
         scroll over the thumb rail. Without this, mouse-primary users
         have no way to discover or use the horizontal scroll (the
         scrollbar is hidden and standard wheels only scroll vertically).
         Trackpad horizontal gestures still work because they generate
         deltaX directly â€” we only redirect deltaY. */
      thumbsEl.addEventListener('wheel', function (e) {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        if (e.deltaY === 0) return;
        /* Only steal the wheel if the rail can still scroll in that
           direction â€” otherwise let the page scroll normally instead of
           swallowing the input at the rail's edges. */
        var canScrollRight = thumbsEl.scrollLeft + thumbsEl.clientWidth < thumbsEl.scrollWidth - 1;
        var canScrollLeft = thumbsEl.scrollLeft > 0;
        if (e.deltaY > 0 && !canScrollRight) return;
        if (e.deltaY < 0 && !canScrollLeft) return;
        e.preventDefault();
        thumbsEl.scrollLeft += e.deltaY;
      }, { passive: false });

      /* Desktop scroll nav buttons. Click scrolls the rail by 75% of
         its visible width â€” far enough to clearly advance, short enough
         that the user can still see context from the previous view. */
      gallery.querySelectorAll('[data-hn-pdp-thumb-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var direction = btn.dataset.hnPdpThumbNav === 'prev' ? -1 : 1;
          var step = Math.round(thumbsEl.clientWidth * 0.75);
          thumbsEl.scrollBy({ left: direction * step, behavior: 'smooth' });
        });
      });
    }
  }

  /* ---------- Variant â†’ gallery sync ----------
     Shopify's <variant-selects> dispatches the native 'change' event
     when an option flips. The matching variant's featured_media.id
     is encoded in the JSON script tag inside the picker. We listen
     on change and look up the new variant by selected option values,
     then trigger the gallery activator. */

  function featuredMediaIdForVariant(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_media_id) return String(variant.featured_media_id);
    return null;
  }

  function activateGalleryVariant(variant) {
    var mediaId = featuredMediaIdForVariant(variant);
    if (!mediaId) return false;
    var gallery = document.querySelector('[data-hn-pdp-gallery]');
    if (gallery && typeof gallery.hnPdpActivate === 'function') {
      gallery.hnPdpActivate(mediaId);
      return true;
    }
    return false;
  }

  var variantGallerySyncBound = false;
  function initVariantSync() {
    if (!variantGallerySyncBound && typeof window.subscribe === 'function') {
      var variantChangeEvent =
        (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) || 'variant-change';
      variantGallerySyncBound = true;
      window.subscribe(variantChangeEvent, function (event) {
        var data = event && event.data;
        activateGalleryVariant(data && data.variant);
      });
    }

    var selects = document.querySelectorAll('variant-selects');
    selects.forEach(function (sel) {
      if (sel.dataset.hnPdpVariantSyncReady === '1') return;
      sel.dataset.hnPdpVariantSyncReady = '1';

      sel.addEventListener('change', function () {
        var script = sel.querySelector('script[type="application/json"]');
        if (!script) return;
        var variants;
        try { variants = JSON.parse(script.textContent); } catch (e) { return; }

        var selected = Array.from(sel.querySelectorAll('input[type="radio"]:checked, select option:checked'))
          .map(function (el) { return (el.value || el.getAttribute('value') || '').trim(); });

        var match = variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(Boolean);
          if (opts.length !== selected.length) return false;
          return opts.every(function (o, i) { return o === selected[i]; });
        });

        activateGalleryVariant(match);
      });
    });
  }

  /* ---------- Variant â†’ ATC label + sticky price repair ----------
     Dawn's <variant-selects> (global.js) re-renders the section on a
     variant change and updates the #price-{section} block for us, but
     two of our CUSTOM spans otherwise go stale:
       1. The ATC button price/label â€” Dawn's toggleAddButton does a
          `.textContent` write on `[name="add"] > span` (our
          .hn-pdp__atc-label), which wipes the nested "Â· $price" and
          replaces the configured label with the generic "Add to cart".
       2. The sticky bar price ([data-hn-pdp-sticky-price]) â€” nothing
          else touches it.
     renderProductInfo publishes PUB_SUB_EVENTS.variantChange AFTER that
     clobber, carrying the freshly server-rendered section HTML. We copy
     the correct label + sticky price straight out of it, so they match
     the #price block exactly and the sold-out / configured-label states
     come from the server render (no client-side money formatting).
     publish() is synchronous, so the repair lands in the same tick as
     the clobber â€” no visible flicker. */
  var variantPriceSyncBound = false;
  function initVariantPriceSync() {
    if (variantPriceSyncBound) return;
    /* subscribe/publish are function declarations in pubsub.js, so they
       ARE on window. PUB_SUB_EVENTS is a top-level `const` in
       constants.js â€” a global LEXICAL binding, NOT a window property â€”
       so reference it bare (the way global.js does) with a literal
       fallback; window.PUB_SUB_EVENTS would be undefined. */
    if (typeof window.subscribe !== 'function') return;
    var variantChangeEvent =
      (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) || 'variant-change';
    variantPriceSyncBound = true;

    window.subscribe(variantChangeEvent, function (event) {
      var data = event && event.data;
      if (!data || !data.html) return;
      var html = data.html; /* parsed Document of the re-rendered section */
      var sectionId = data.sectionId;

      /* ATC button label: scope to the section's submit button so
         nothing else can match, with an unscoped fallback. */
      var liveBtn = sectionId ? document.getElementById('ProductSubmitButton-' + sectionId) : null;
      var liveLabel = (liveBtn && liveBtn.querySelector('[data-hn-pdp-atc-label]')) ||
        document.querySelector('[data-hn-pdp-atc-label]');
      var srcBtn = sectionId ? html.getElementById('ProductSubmitButton-' + sectionId) : null;
      var srcLabel = (srcBtn && srcBtn.querySelector('[data-hn-pdp-atc-label]')) ||
        html.querySelector('[data-hn-pdp-atc-label]');
      if (liveLabel && srcLabel) liveLabel.innerHTML = srcLabel.innerHTML;

      /* Sticky bar price. */
      var liveSticky = document.querySelector('[data-hn-pdp-sticky-price]');
      var srcSticky = html.querySelector('[data-hn-pdp-sticky-price]');
      if (liveSticky && srcSticky) liveSticky.textContent = srcSticky.textContent;

      /* The copied label and sticky price carry the new variant's unit price.
         Re-apply current qty and any active order discount preview. */
      updateStandardOrderPricing();
    });
  }

  function initCtaScroll() {
    document.querySelectorAll('[data-hn-pdp-cta-scroll]').forEach(function (button) {
      if (button.dataset.hnPdpCtaScrollReady === '1') return;
      button.dataset.hnPdpCtaScrollReady = '1';

      button.addEventListener('click', function (event) {
        var target = document.querySelector('[data-hn-pdp-buy]');
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  /* ---------- Sticky ATC bar ----------
     IntersectionObserver on the buy column. Reveal the bar when the
     column is out of viewport. Hide while it's visible (the in-page
     ATC is already on screen). */

  function initStickyBar() {
    var buy = document.querySelector('[data-hn-pdp-buy]');
    var bar = document.querySelector('[data-hn-pdp-sticky]');
    if (!buy || !bar) return;
    if (bar.dataset.hnPdpStickyReady === '1') return;

    /* Mobile-only. The sticky buy column inside the hero already
       gives desktop users a persistent ATC; layering a second one
       at the bottom adds visual clutter without conversion lift
       (see CSS comment for the research backing). Bail before
       attaching the observer so we don't waste cycles when the bar
       is display:none anyway.

       Re-evaluated on viewport changes so a rotated tablet or
       resized desktop window correctly picks up / drops the bar. */
    var mobileMQ = window.matchMedia('(max-width: 749px)');
    if (!mobileMQ.matches) {
      /* Listen for the user crossing into mobile size; re-init
         when they do. Avoids permanently breaking the bar on a
         page-load that started in landscape. */
      var rebind = function (e) {
        if (e.matches) {
          mobileMQ.removeEventListener('change', rebind);
          initStickyBar();
        }
      };
      if (typeof mobileMQ.addEventListener === 'function') {
        mobileMQ.addEventListener('change', rebind);
      }
      return;
    }

    bar.dataset.hnPdpStickyReady = '1';
    if (!('IntersectionObserver' in window)) return;

    /* Measure the bar once and publish as a CSS var so the body
       can reserve matching bottom padding when the bar is visible.
       Without this, content at the very bottom of the page can
       get trapped under the fixed bar. Re-measure on resize since
       safe-area-inset can change (e.g. iPhone rotation). */
    var setBarHeightVar = function () {
      var h = bar.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--hn-stickybar-h', h + 'px');
      }
    };
    setBarHeightVar();
    window.addEventListener('resize', setBarHeightVar, { passive: true });

    /* Visibility state is the AND of two conditions:
         1. User has scrolled PAST the buy column (in-page ATC
            no longer on screen, so the persistent bar is useful)
         2. The Final CTA section is NOT yet in view (we don't
            want to compete with the page's designated closing
            moment; the Final CTA has its own prominent button)

       Two IntersectionObservers feed flags into a single
       applyVisibility() so all the side effects (bar class,
       aria, body-padding class) stay in one place. */

    var pastBuyColumn = false;
    var finalCtaInView = false;

    var applyVisibility = function () {
      var visible = pastBuyColumn && !finalCtaInView;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('hn-stickybar-on', visible);
    };

    /* Observer 1: buy column. Bar is "available" once the column
       has scrolled past the viewport bottom (entry.isIntersecting
       false AND boundingClientRect.top < 0 means the column is
       above the viewport, not below it). */
    var buyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var top = entry.boundingClientRect.top;
        pastBuyColumn = !entry.isIntersecting && top < 0;
        applyVisibility();
      });
    }, { threshold: [0, 0.01] });
    buyObserver.observe(buy);

    /* Observer 2: Final CTA section. Hide the bar as soon as any
       part of the Final CTA enters the viewport AND keep it
       hidden after the user scrolls past into the footer (the
       footer isn't a place for a persistent ATC either â€” it'd
       cover the policy links + newsletter signup).

       The flag is true whenever the CTA is currently visible
       OR has been scrolled past (`boundingClientRect.top < 0`
       means its top edge is above the viewport top). When the
       user scrolls back up OUT of the CTA from the top, the
       condition flips false and the bar reappears for the
       informational content above. */
    var finalCta = document.querySelector('.hn-pdp-cta');
    if (finalCta) {
      var ctaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          finalCtaInView =
            entry.isIntersecting ||
            entry.boundingClientRect.top < 0;
          applyVisibility();
        });
      }, {
        threshold: 0
      });
      ctaObserver.observe(finalCta);
    }

    /* Loading state for the submit-mode sticky CTA. The button
       submits the main product form via form="..." which Dawn's
       <product-form> handles via AJAX. Dawn applies its loading
       class to its OWN submit button (.product-form__submit),
       not the sticky bar's button â€” so without this hook the
       sticky CTA looks frozen while the add is in flight.

       Click â†’ add `is-loading` class + aria-busy immediately so
       the user sees instant feedback. Dawn fires cartUpdate via
       pubsub after the add completes (success or failure); we
       use that to clear the loading state.

       Only the submit-mode button needs this. The scroll-mode
       button (data-hn-pdp-cta-scroll) just scrolls â€” no add,
       no loading. */
    var stickyCta = bar.querySelector('button[type="submit"].hn-pdp-stickybar__cta');
    if (stickyCta) {
      var clearStickyLoading = function () {
        stickyCta.classList.remove('is-loading');
        stickyCta.removeAttribute('aria-busy');
      };

      /* Single click handler: marks loading state + arms a 6s
         safety timeout in case neither cartUpdate nor cartError
         fires (custom theme overrides, blocked scripts, etc.).
         Bails when the button is already loading so rapid taps
         don't pile up safety timeouts. */
      stickyCta.addEventListener('click', function () {
        if (stickyCta.disabled) return;
        if (stickyCta.classList.contains('is-loading')) return;
        stickyCta.classList.add('is-loading');
        stickyCta.setAttribute('aria-busy', 'true');
        setTimeout(clearStickyLoading, 6000);
      });

      /* Hook into Dawn's PUB_SUB_EVENTS when available, falls
         back to the custom cart event from hn-cart-drawer.js.
         hn-pdp-main.js is defer-loaded after pubsub.js (which
         is also defer + earlier in document order), so
         window.subscribe is guaranteed to be defined by the
         time init runs. */
      /* PUB_SUB_EVENTS is a bare const in constants.js (a classic
         script), so it never lands on window; only the bare reference
         resolves. */
      if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        if (PUB_SUB_EVENTS.cartUpdate) {
          window.subscribe(PUB_SUB_EVENTS.cartUpdate, clearStickyLoading);
        }
        if (PUB_SUB_EVENTS.cartError) {
          window.subscribe(PUB_SUB_EVENTS.cartError, clearStickyLoading);
        }
      }
      document.addEventListener('hn:cart:updated', clearStickyLoading);
    }
  }

  /* ---------- Rating link â†’ smooth scroll to reviews ----------
     Browser anchor jumping is unreliable here: the apps-section
     wrapper ID format depends on Shopify internals, and the Okendo
     widget loads async (target may have zero height when clicked).
     Resolve the destination by stable class on every click. */

  function initRatingScroll() {
    document.querySelectorAll('.hn-pdp__rating').forEach(function (link) {
      if (link.dataset.hnPdpRatingReady === '1') return;
      link.dataset.hnPdpRatingReady = '1';

      /* The reviews live in an app section (Judge.me) whose DOM id
         depends on the template, so resolve it on the page instead of
         trusting a hard-coded hash. The section wrapper is server
         rendered, so it exists before the widget itself loads. */
      function findReviewsTarget() {
        return (
          document.querySelector('[id^="shopify-section-"][id*="judgeme" i]') ||
          document.querySelector('[id^="shopify-section-"][id*="review" i]') ||
          document.querySelector('.jdgm-review-widget, #judgeme_product_reviews') ||
          document.querySelector('[id^="shopify-block-"][id*="review" i]')
        );
      }

      /* Point the href at the real id so the link is a true anchor
         (keyboard, open in new tab, copy link). */
      var found = findReviewsTarget();
      if (found && found.id) link.setAttribute('href', '#' + found.id);

      link.addEventListener('click', function (e) {
        var target = findReviewsTarget();
        if (!target) return; /* let the default href run */

        e.preventDefault();
        var header = document.querySelector('sticky-header, .header-wrapper');
        var headerOffset = (header ? header.offsetHeight : 0) + 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    });
  }

  /* ---------- Bundle picker ----------
     Tier selection + per-slot variant tracking + multi-line-item cart
     add. Shopify Auto Discounts (configured in Admin) handle the actual
     pricing at checkout; the JS just updates display prices and posts
     the right items array. */

  function initBundles() {
    var containers = document.querySelectorAll('[data-hn-pdp-bundles]');
    containers.forEach(function (container) {
      if (container.dataset.hnPdpBundlesReady === '1') return;
      container.dataset.hnPdpBundlesReady = '1';

      var sectionId = container.dataset.sectionId;

      var tiers = Array.prototype.slice.call(container.querySelectorAll('[data-hn-pdp-bundle-tier]'));
      if (!tiers.length) return;
      var atc = document.querySelector('[data-hn-pdp-bundle-atc][data-section-id="' + sectionId + '"]');
      var atcPriceEl = atc ? atc.querySelector('[data-hn-pdp-atc-price]') : null;
      var atcCompareEl = atc ? atc.querySelector('[data-hn-pdp-atc-compare]') : null;
      var stockNote = document.querySelector('[data-hn-pdp-bundle-stock-note][data-section-id="' + sectionId + '"]');
      var productData = readPdpProductData();

      /* Comfort Club opt-in (snippets/cc-pdp-purchase): a "Subscribe & get
         a free Comfort Puff" checkbox under the tiers. Ticked, the tiers price and
         badge themselves at the Club rates (each percentage shown is the
         total saving) and the 1, 2 or 3 month schedule opens. The Club
         saving follows the box size (config tiers); lines go in with the
         plan for that schedule and saving, and assets/cc-cart.js settles
         the whole cart afterwards. */
      var club = document.querySelector('[data-cc-pdp][data-section-id="' + sectionId + '"]');
      var clubToggle = club ? club.querySelector('[data-cc-pdp-toggle]') : null;
      var clubNote = club ? club.querySelector('[data-cc-pdp-note]') : null;
      var clubConfig = null;
      if (club) {
        try {
          clubConfig = JSON.parse(club.querySelector('[data-cc-pdp-config]').textContent);
          clubConfig.tierList = String(clubConfig.tiers || '')
            .split(',')
            .map(function (pair) {
              var parts = pair.split(':');
              return { qty: parseInt(parts[0], 10), pct: parseFloat(parts[1]) };
            })
            .filter(function (tier) { return tier.qty > 0 && !isNaN(tier.pct); });
        } catch (e) {
          club = null;
        }
      }

      function clubSelected() {
        return !!(clubToggle && clubToggle.checked);
      }

      function clubMonths() {
        var radio = club ? club.querySelector('[data-cc-pdp-every]:checked') : null;
        return radio ? parseInt(radio.value, 10) : 2;
      }

      function clubPct(count) {
        var pct = 0;
        clubConfig.tierList.forEach(function (tier) {
          if (count >= tier.qty) pct = tier.pct;
        });
        return pct;
      }

      function clubPlanId(months, pct) {
        var plans = clubConfig.plans || [];
        for (var i = 0; i < plans.length; i++) {
          if (plans[i].months === months && plans[i].pct === pct) return plans[i].id;
        }
        return null;
      }

      /* The tier priced as a Club box, or eligible: false when a slot holds
         a variant the Club does not carry (the 4oz Fragrance-Free). Plan
         prices round per unit, as Shopify's selling plan prices do. */
      function clubTotals(tier) {
        var slots = tier.querySelectorAll('[data-hn-pdp-bundle-slot]');
        var pct = clubPct(slots.length);
        var eligible = slots.length > 0 && !!clubPlanId(clubMonths(), pct);
        var raw = 0;
        var total = 0;
        slots.forEach(function (slot) {
          var opt = slot.options[slot.selectedIndex];
          if (!opt || !opt.dataset.price) return;
          if (clubConfig.eligible.indexOf(parseInt(opt.value, 10)) === -1) eligible = false;
          var unit = parseInt(opt.dataset.price, 10) || 0;
          raw += unit;
          total += Math.round(unit * (100 - pct) / 100);
        });
        return { eligible: eligible, pct: pct, raw: raw, total: total };
      }

      /* Tier badge + compare follow the purchase option; the one-time
         markup is kept so switching back restores it exactly. */
      function setTierClubDisplay(tier, clubInfo) {
        var badge = tier.querySelector('.hn-pdp__bundle-tier-badge');
        var main = tier.querySelector('.hn-pdp__bundle-tier-main');
        if (badge && badge.dataset.ccOnceText === undefined) badge.dataset.ccOnceText = badge.textContent;
        if (clubInfo) {
          if (!badge && main) {
            badge = document.createElement('span');
            badge.className = 'hn-pdp__bundle-tier-badge';
            badge.dataset.ccOnceText = '';
            main.appendChild(badge);
          }
          if (badge) {
            badge.hidden = false;
            badge.textContent = clubInfo.pct + '% OFF';
          }
        } else if (badge) {
          badge.textContent = badge.dataset.ccOnceText;
          badge.hidden = !badge.dataset.ccOnceText;
        }

        var pricing = tier.querySelector('.hn-pdp__bundle-tier-pricing');
        var compareEl = tier.querySelector('[data-hn-pdp-tier-compare]');
        if (clubInfo && !compareEl && pricing) {
          compareEl = document.createElement('s');
          compareEl.className = 'hn-pdp__bundle-tier-compare';
          compareEl.setAttribute('data-hn-pdp-tier-compare', '');
          compareEl.dataset.ccAdded = '1';
          pricing.appendChild(compareEl);
        }
        if (compareEl && compareEl.dataset.ccAdded === '1') compareEl.hidden = !clubInfo;
      }

      function currentProductData() {
        productData = readPdpProductData() || productData;
        return productData;
      }

      function selectedTier() {
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].classList.contains('is-selected')) return tiers[i];
        }
        return null;
      }

      function variantOptions(variant) {
        if (!variant) return [];
        if (Array.isArray(variant.options)) return variant.options;
        return [variant.option1, variant.option2, variant.option3].filter(Boolean);
      }

      function findNativeOption(select, value) {
        if (!select) return null;
        var stringValue = String(value);
        for (var i = 0; i < select.options.length; i++) {
          if (String(select.options[i].value) === stringValue) return select.options[i];
        }
        return null;
      }

      function refreshSelectUi(select) {
        var wrapper = select ? select.closest('hn-select') : null;
        if (wrapper && typeof wrapper.refreshOptions === 'function') {
          wrapper.refreshOptions();
        }
      }

      function baseOptionLabel(option) {
        if (!option) return '';
        if (!option.dataset.hnPdpBaseLabel) {
          option.dataset.hnPdpBaseLabel = option.textContent.replace(/\s*\((?:Sold out|Not in [^)]*)\)\s*$/i, '').trim();
        }
        return option.dataset.hnPdpBaseLabel;
      }

      function setOptionSoldOut(option, soldOut, reason) {
        if (!option) return;
        var label = baseOptionLabel(option);
        option.disabled = !!soldOut;
        option.textContent = soldOut ? label + ' (' + (reason || 'Sold out') + ')' : label;
      }

      /* True when at least one addable variant carries this value at this
         option position, whatever the other selects say. Lets the label tell
         "sold out everywhere" apart from "not made in the size you picked". */
      function optionValueAvailableAnywhere(optionIndex, value, hiddenSelect) {
        var data = currentProductData();
        var variants = data && data.variants ? data.variants : [];
        for (var i = 0; i < variants.length; i++) {
          if (String(variantOptions(variants[i])[optionIndex]) !== String(value)) continue;
          if (bundleVariantChoiceAvailable(variants[i], hiddenSelect)) return true;
        }
        return false;
      }

      function variantCanBeAdded(variant) {
        var info = variantAddableInfo(variant, currentProductData());
        return !!(info && info.cap > 0);
      }

      function bundleVariantChoiceAvailable(variant, hiddenSelect) {
        if (!variant || !hiddenSelect) return false;
        var nativeOption = findNativeOption(hiddenSelect, variant.id);
        return !!(nativeOption && variantCanBeAdded(variant));
      }

      function findVariantForOptions(values, hiddenSelect) {
        var data = currentProductData();
        if (!data || !Array.isArray(data.variants)) return null;
        for (var i = 0; i < data.variants.length; i++) {
          var variant = data.variants[i];
          var options = variantOptions(variant);
          var matches = values.every(function (value, index) {
            return String(options[index]) === String(value);
          });
          if (!matches) continue;
          if (hiddenSelect && !findNativeOption(hiddenSelect, variant.id)) continue;
          return variant;
        }
        return null;
      }

      function applyBundleOptionFieldAvailability(slotEl) {
        if (!slotEl) return false;
        var hiddenSelect = slotEl.querySelector('[data-hn-pdp-bundle-slot]');
        var optionSelects = Array.from(slotEl.querySelectorAll('[data-hn-pdp-bundle-option]'));
        if (!hiddenSelect || !optionSelects.length) return false;

        var changed = false;
        optionSelects.forEach(function (select, selectIndex) {
          var firstAvailableValue = null;
          Array.from(select.options).forEach(function (option) {
            var values = optionSelects.map(function (candidateSelect, valueIndex) {
              return valueIndex === selectIndex ? option.value : candidateSelect.value;
            });
            var variant = findVariantForOptions(values, hiddenSelect);
            var available = bundleVariantChoiceAvailable(variant, hiddenSelect);
            var reason = '';
            /* Size leads, scent follows. A size stays pickable whenever any
               scent comes in it; the scent select then drops to the first
               scent made in that size. Tying both selects to each other
               locked shoppers out (scent "not in 6oz", size "not in this
               scent") with no way to reach the 4oz scents. */
            if (!available && isSharedSizeSelect(select)) {
              available = optionValueAvailableAnywhere(selectIndex, option.value, hiddenSelect);
            }
            if (!available && optionValueAvailableAnywhere(selectIndex, option.value, hiddenSelect)) {
              var others = values.filter(function (value, valueIndex) { return valueIndex !== selectIndex; });
              reason = 'Not in ' + others.join(', ');
            }
            setOptionSoldOut(option, !available, reason);
            if (available && firstAvailableValue === null) firstAvailableValue = option.value;
          });

          var selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.disabled && firstAvailableValue !== null) {
            select.value = firstAvailableValue;
            changed = true;
          }
          refreshSelectUi(select);
        });

        return changed;
      }

      function updateBundleOptionFieldAvailability(slotEl) {
        var changed = applyBundleOptionFieldAvailability(slotEl);
        if (changed) applyBundleOptionFieldAvailability(slotEl);
      }

      function updateDirectBundleSlotAvailability(select) {
        if (!select || select.classList.contains('hn-pdp__bundle-slot-select--hidden')) return true;
        var firstAvailableValue = null;
        Array.from(select.options).forEach(function (option) {
          var variant = findVariantById(currentProductData(), option.value);
          var available = variantCanBeAdded(variant);
          setOptionSoldOut(option, !available);
          if (available && firstAvailableValue === null) firstAvailableValue = option.value;
        });

        var selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.disabled && firstAvailableValue !== null) {
          select.value = firstAvailableValue;
        }
        refreshSelectUi(select);

        selectedOption = select.options[select.selectedIndex];
        return !!(selectedOption && !selectedOption.disabled);
      }

      function activateBundleSlotVariant(slotEl, select) {
        var variantSelect = select || (slotEl ? slotEl.querySelector('[data-hn-pdp-bundle-slot]') : null);
        if (!variantSelect || !variantSelect.value) return;
        var variant = findVariantById(currentProductData(), variantSelect.value);
        activateGalleryVariant(variant);
      }

      function updateTierAvailability(tier) {
        var valid = true;

        tier.querySelectorAll('[data-hn-pdp-bundle-option-fields]').forEach(function (fields) {
          var slotEl = fields.closest('.hn-pdp__bundle-slot');
          updateBundleOptionFieldAvailability(slotEl);
        });

        tier.querySelectorAll('[data-hn-pdp-bundle-slot]').forEach(function (select) {
          if (!updateDirectBundleSlotAvailability(select)) valid = false;
        });

        return valid;
      }

      function syncSlotVariant(slotEl, notify) {
        if (!slotEl) return true;
        var hiddenSelect = slotEl.querySelector('[data-hn-pdp-bundle-slot]');
        var optionSelects = slotEl.querySelectorAll('[data-hn-pdp-bundle-option]');
        if (!hiddenSelect || !optionSelects.length) return true;

        var values = Array.from(optionSelects).map(function (select) {
          return select.value;
        });
        var variant = findVariantForOptions(values, hiddenSelect);
        var nativeOption = variant ? findNativeOption(hiddenSelect, variant.id) : null;
        var isAvailable = !!(variant && nativeOption && !nativeOption.disabled && variantCanBeAdded(variant));

        if (nativeOption) {
          hiddenSelect.value = nativeOption.value;
          if (notify) hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        slotEl.classList.toggle('is-unavailable', !isAvailable);
        return isAvailable;
      }

      function syncTierVariants(tier, notify) {
        var valid = true;
        tier.querySelectorAll('[data-hn-pdp-bundle-option-fields]').forEach(function (fields) {
          var slotEl = fields.closest('.hn-pdp__bundle-slot');
          if (!syncSlotVariant(slotEl, notify)) valid = false;
        });
        return valid;
      }

      function isSharedSizeSelect(select) {
        if (!select) return false;
        var name = (select.dataset.optionName || '').toLowerCase();
        return name.indexOf('size') !== -1;
      }

      function syncSharedSizeSelections(sourceSelect) {
        if (!isSharedSizeSelect(sourceSelect)) return;
        var value = sourceSelect.value;
        container.querySelectorAll('[data-hn-pdp-bundle-option]').forEach(function (select) {
          if (!isSharedSizeSelect(select)) return;
          if (select === sourceSelect || select.value === value) return;
          var matchingOption = findNativeOption(select, value);
          if (!matchingOption || matchingOption.disabled) return;
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      function computeTierTotals(tier) {
        var isValid = updateTierAvailability(tier);
        if (!syncTierVariants(tier, false)) isValid = false;
        var inventoryMessage = bundleInventoryMessage(tier, currentProductData());
        if (inventoryMessage) isValid = false;
        if (!isValid && !inventoryMessage) inventoryMessage = 'This option is sold out.';
        var pct = parseFloat(tier.dataset.tierPct) || 0;
        var slots = tier.querySelectorAll('[data-hn-pdp-bundle-slot]');
        var rawTotalCents = 0;
        var discountedTotalCents = 0;
        var orderPct = orderDiscountPct();
        var grouped = {};
        /* Per-unit floor bundle rounding to mirror Shopify's checkout math.
           Group slots by variant so a confirmed order discount is applied
           after the bundle tier to the same line shape the cart will use. */
        slots.forEach(function (slot) {
          var opt = slot.options[slot.selectedIndex];
          if (!opt || !opt.dataset.price) return;
          var variantId = opt.value || '';
          var unitPrice = parseInt(opt.dataset.price, 10) || 0;
          rawTotalCents += unitPrice;
          if (!grouped[variantId]) grouped[variantId] = { unitPrice: unitPrice, qty: 0 };
          grouped[variantId].qty += 1;
        });
        Object.keys(grouped).forEach(function (variantId) {
          var item = grouped[variantId];
          var discount = pct > 0 ? Math.floor(item.unitPrice * pct / 100) : 0;
          var afterBundle = (item.unitPrice - discount) * item.qty;
          discountedTotalCents += finalAfterOrder(afterBundle, orderPct);
        });
        return {
          isValid: isValid,
          inventoryMessage: inventoryMessage,
          rawTotalCents: rawTotalCents,
          discountedTotalCents: discountedTotalCents
        };
      }

      function updateTierPrice(tier) {
        var totals = computeTierTotals(tier);
        totals.onceTotalCents = totals.discountedTotalCents;
        if (club) {
          totals.club = clubTotals(tier);
          if (clubSelected() && totals.club.eligible) {
            totals.discountedTotalCents = totals.club.total;
            setTierClubDisplay(tier, totals.club);
          } else {
            setTierClubDisplay(tier, null);
          }
        }
        var priceEl = tier.querySelector('[data-hn-pdp-tier-price]');
        var compareEl = tier.querySelector('[data-hn-pdp-tier-compare]');

        if (priceEl) priceEl.textContent = formatMoney(totals.discountedTotalCents);
        if (compareEl) compareEl.textContent = formatMoney(totals.rawTotalCents);

        return totals;
      }

      /* The strip's state, its Club rate, the schedule, the renewal terms
         and the ATC wording. A pick the Club does not carry unticks the
         strip and shows a note instead. */
      function updateClubOptions(totals) {
        if (!club || !clubToggle || !totals || !totals.club) return;
        var info = totals.club;
        clubToggle.disabled = !info.eligible;
        if (!info.eligible && clubToggle.checked) {
          clubToggle.checked = false;
          recalcAtcPrice();
          return;
        }
        if (clubNote) clubNote.hidden = info.eligible;

        var isClub = clubSelected();
        var offer = club.querySelector('[data-cc-pdp-offer]');
        if (offer) {
          offer.classList.toggle('is-checked', isClub);
          offer.classList.toggle('is-disabled', !info.eligible);
        }
        var everyWrap = club.querySelector('[data-cc-pdp-every-wrap]');
        if (everyWrap) everyWrap.hidden = !isClub;

        var pctEl = club.querySelector('[data-cc-pdp-pct]');
        if (pctEl) pctEl.textContent = String(info.pct || clubPct(1));

        /* Timeline under the schedule: the first box today (with the free
           Puff), then the renewal price, schedule and first renewal date. */
        var terms = club.querySelector('[data-cc-pdp-terms]');
        if (terms) {
          var months = clubMonths();
          terms.hidden = !isClub;
          var firstEl = terms.querySelector('[data-cc-pdp-first-price]');
          var thenLabel = terms.querySelector('[data-cc-pdp-then-label]');
          var thenWhen = terms.querySelector('[data-cc-pdp-then-when]');
          var thenEl = terms.querySelector('[data-cc-pdp-then]');
          var next = new Date();
          next.setMonth(next.getMonth() + months);
          var nextText = next.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
          if (firstEl) firstEl.textContent = formatMoney(info.total);
          if (thenLabel) thenLabel.textContent = 'Every ' + (months === 1 ? 'month' : months + ' months');
          if (thenWhen) thenWhen.textContent = 'from ' + nextText;
          if (thenEl) thenEl.textContent = formatMoney(info.total);
        }

        var atcText = atc ? atc.querySelector('[data-hn-pdp-atc-text]') : null;
        if (atcText) {
          if (atcText.dataset.ccOnceText === undefined) atcText.dataset.ccOnceText = atcText.textContent;
          atcText.textContent = isClub ? 'Subscribe' : atcText.dataset.ccOnceText;
        }
      }

      function recalcAtcPrice() {
        var tier = selectedTier();
        if (!tier) return;

        var selectedTotals = null;
        tiers.forEach(function (candidate) {
          var totals = updateTierPrice(candidate);
          if (candidate === tier) selectedTotals = totals;
        });

        if (atcPriceEl && selectedTotals) {
          atcPriceEl.textContent = formatMoney(selectedTotals.discountedTotalCents);
        }
        if (atcCompareEl && selectedTotals) {
          atcCompareEl.textContent = selectedTotals.rawTotalCents > selectedTotals.discountedTotalCents
            ? formatMoney(selectedTotals.rawTotalCents)
            : '';
        }
        if (selectedTotals) {
          setStockNote(stockNote, selectedTotals.inventoryMessage || '', !selectedTotals.isValid);
        }
        if (atc && selectedTotals) atc.toggleAttribute('disabled', !selectedTotals.isValid);
        updateClubOptions(selectedTotals);
      }

      function buildBundleAnalyticsContext(tier, mergedItems, totals) {
        var data = currentProductData();
        var pct = parseFloat(tier.dataset.tierPct) || 0;
        var tierQty = parseInt(tier.dataset.tierQty, 10) || 1;
        var tierLabel = tier.dataset.tierLabel || (tierQty + ' Pack');
        var valueCents = 0;
        var items = [];

        mergedItems.forEach(function (line) {
          var variant = findVariantById(data, line.id);
          if (!variant) return;
          var qty = parseInt(line.quantity, 10) || 1;
          var unitCents = parseInt(variant.price, 10) || 0;
          var unitDiscountCents = pct > 0 ? Math.floor(unitCents * pct / 100) : 0;
          var netUnitCents = unitCents - unitDiscountCents;
          valueCents += netUnitCents * qty;

          items.push({
            item_id: String(variant.id || ''),
            item_name: data && data.title ? data.title : '',
            item_variant: variant.title || '',
            item_brand: data && data.vendor ? data.vendor : '',
            item_category: data && data.type ? data.type : '',
            item_product_id: data && data.id ? String(data.id) : '',
            item_variant_id: String(variant.id || ''),
            item_sku: variant.sku || '',
            item_handle: data && data.handle ? data.handle : '',
            price: netUnitCents / 100,
            discount: unitDiscountCents / 100,
            quantity: qty,
            bundle_label: tierLabel,
            bundle_qty: tierQty,
            bundle_discount_pct: pct
          });
        });

        if (totals && typeof totals.discountedTotalCents === 'number') {
          valueCents = totals.discountedTotalCents;
        }

        return {
          ecommerce: {
            currency: window.HnAnalytics && typeof window.HnAnalytics.currencyCode === 'function'
              ? window.HnAnalytics.currencyCode()
              : 'USD',
            value: valueCents / 100,
            items: items
          },
          params: {
            cart_source: 'pdp_bundle',
            bundle_tier_id: tier.getAttribute('data-tier-id') || '',
            bundle_label: tierLabel,
            bundle_qty: tierQty,
            bundle_discount_pct: pct,
            bundle_variant_count: mergedItems.length
          }
        };
      }

      function selectTier(tierEl) {
        var prevTier = selectedTier();
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tierEl.classList.add('is-selected');
        var radio = tierEl.querySelector('[data-hn-pdp-bundle-radio]');
        if (radio) radio.checked = true;
        recalcAtcPrice();

        /* Tier consideration telemetry (M3c, Supabase only): records
           genuine switches so "considered the 3-pack, bought the 1-pack"
           becomes visible. The init default (no prior selection) and
           re-clicks of the current tier are not consideration signals. */
        if (prevTier && prevTier !== tierEl && window.HnTelemetry && typeof window.HnTelemetry.recordEvent === 'function') {
          try {
            window.HnTelemetry.recordEvent('hi_pdp_tier_select', {
              from_tier: prevTier.getAttribute('data-tier-id') || '',
              to_tier: tierEl.getAttribute('data-tier-id') || ''
            });
          } catch (e) {}
        }
      }

      if (!selectedTier()) {
        selectTier(tiers[tiers.length - 1]);
      }

      tiers.forEach(function (tier) {
        var radio = tier.querySelector('[data-hn-pdp-bundle-radio]');
        if (radio) {
          radio.addEventListener('change', function () {
            if (radio.checked) selectTier(tier);
          });
        }
        /* Clicking the row label fires the radio change, but defending
           against subtle event swallowing in some browsers. */
        tier.addEventListener('click', function (e) {
          /* Don't hijack clicks on the slot dropdowns. */
          if (e.target.closest('[data-hn-pdp-bundle-slot], [data-hn-pdp-bundle-option], hn-select')) return;
          selectTier(tier);
        });

        /* Per-slot variant changes â†’ recompute display */
        tier.querySelectorAll('[data-hn-pdp-bundle-slot]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            updateDirectBundleSlotAvailability(sel);
            activateBundleSlotVariant(sel.closest('.hn-pdp__bundle-slot'), sel);
            recalcAtcPrice();
          });
          /* Stop the click on the select from bubbling into the tier
             handler (which would re-select the tier and feel like a
             phantom action). */
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
        });

        tier.querySelectorAll('[data-hn-pdp-bundle-option]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            syncSharedSizeSelections(sel);
            var slotEl = sel.closest('.hn-pdp__bundle-slot');
            updateBundleOptionFieldAvailability(slotEl);
            syncSlotVariant(slotEl, true);
            activateBundleSlotVariant(slotEl);
            recalcAtcPrice();
          });
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
        });
      });

      /* ATC: multi-line-item add. */
      if (atc) {
        atc.addEventListener('click', function (e) {
          e.preventDefault();
          if (atc.hasAttribute('disabled') || atc.classList.contains('loading')) return;

          var tier = selectedTier();
          if (!tier) return;
          var tierQty = parseInt(tier.dataset.tierQty, 10) || 1;
          var tierLabel = tier.dataset.tierLabel || (tierQty + ' Pack');
          updateTierAvailability(tier);
          if (!syncTierVariants(tier, false)) return;
          var stockTotals = computeTierTotals(tier);
          if (!stockTotals.isValid) {
            setStockNote(stockNote, stockTotals.inventoryMessage || 'This selection is unavailable.', true);
            return;
          }
          var slots = tier.querySelectorAll('[data-hn-pdp-bundle-slot]');
          var items = [];
          slots.forEach(function (slot) {
            var id = parseInt(slot.value, 10);
            var opt = slot.options[slot.selectedIndex];
            if (id && opt && !opt.disabled) items.push({ id: id, quantity: 1 });
          });
          if (!items.length) return;

          /* Merge identical variants into one line with summed qty so
             the cart shows clean lines instead of repeated entries. */
          var merged = {};
          items.forEach(function (it) {
            merged[it.id] = (merged[it.id] || 0) + it.quantity;
          });
          var mergedItems = Object.keys(merged).map(function (id) {
            return { id: parseInt(id, 10), quantity: merged[id] };
          });

          /* Every line records its add-time provenance (which picker
             tier created it). This is immutable: the cart-side
             reconciler in hn-cart-drawer.js maintains the _hn_bundle_*
             properties as the cart changes but never touches
             _hn_source. Cart value at add time (numeric, cents, read
             from the drawer's server-rendered checkout button) is
             stamped ONLY on multi-pack tiers: their per-add unique
             _hn_bundle_id already prevents Shopify's identical-line
             merging, so a varying value costs nothing. 1-Packs keep
             static properties so repeat adds merge into one cart line. */
          var cartValueEl = document.querySelector('[data-hn-cart-value-cents]');
          var cartValueAtAdd = cartValueEl ? parseInt(cartValueEl.getAttribute('data-hn-cart-value-cents'), 10) : NaN;
          mergedItems.forEach(function (it) {
            it.properties = { _hn_source: 'PDP bundle picker - ' + tierLabel + ' selected' };
            if (tierQty > 1 && !isNaN(cartValueAtAdd)) it.properties._hn_cart_value_cents = String(cartValueAtAdd);
          });

          /* Multi-pack bundles: stamp every line item with a shared
             id + human label. 1-Packs skip these (they render as a
             normal line item until the reconciler sees the group
             qualify). These reflect the tier at ADD time; the
             reconciler rewrites them to the EFFECTIVE tier whenever
             the product group's total quantity changes. */
          if (tierQty > 1) {
            var bundleId = 'b_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
            mergedItems.forEach(function (it) {
              it.properties._hn_bundle_id = bundleId;
              it.properties._hn_bundle_label = tierLabel;
            });
          }

          var clubPlan = null;
          if (club && clubSelected()) {
            var clubInfo = clubTotals(tier);
            clubPlan = clubInfo.eligible ? clubPlanId(clubMonths(), clubInfo.pct) : null;
            if (!clubPlan) return;
            /* Subscription lines are never packs and carry no properties:
               Recharge copies line properties onto every renewal. */
            mergedItems.forEach(function (it) {
              it.selling_plan = clubPlan;
              delete it.properties;
            });
            stockTotals.discountedTotalCents = clubInfo.total;
          }

          var bundleAnalytics = buildBundleAnalyticsContext(tier, mergedItems, stockTotals);
          if (clubPlan) {
            bundleAnalytics.params.purchase_type = 'subscription';
            bundleAnalytics.params.subscription_months = clubMonths();
          }
          var added = bundleAddToCart(mergedItems, atc, bundleAnalytics);
          /* Where the Club box started, on the order (assets/cc-cart.js). */
          if (clubPlan && window.ccCart && typeof window.ccCart.markSource === 'function') {
            added.then(function () {
              return window.ccCart.markSource('product:' + window.location.pathname);
            });
          }
        });
      }

      if (club) {
        club.querySelectorAll('[data-cc-pdp-toggle], [data-cc-pdp-every]').forEach(function (input) {
          input.addEventListener('change', recalcAtcPrice);
        });
        /* Comfort Club opt-in and schedule picks, for the session journey. */
        var clubHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
        var lastMonths = clubMonths();
        var clubTrack = function (name, params) {
          if (!window.HnTelemetry || typeof window.HnTelemetry.recordEvent !== 'function') return;
          try { window.HnTelemetry.recordEvent(name, params); } catch (e) {}
        };
        if (clubToggle) {
          clubToggle.addEventListener('change', function () {
            clubTrack('hi_club_toggle', { on: clubToggle.checked, months: clubMonths(), handle: clubHandle, surface: 'pdp' });
          });
        }
        club.querySelectorAll('[data-cc-pdp-every]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            var months = clubMonths();
            if (months === lastMonths) return;
            clubTrack('hi_club_schedule_change', { surface: 'pdp', months: months, from_months: lastMonths, handle: clubHandle });
            lastMonths = months;
          });
        });
      }

      /* Initial price calc */
      recalcAtcPrice();
      document.addEventListener('hn:pdp:inventory-refresh', recalcAtcPrice);
    });
  }

  function formatMoney(cents) {
    /* Use Shopify's money format helper when available, else a
       basic USD fallback. The window.Shopify object is exposed by
       all Shopify storefronts. */
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      var fmt = window.Shopify.currency && window.Shopify.currency.format
        ? window.Shopify.currency.format
        : '${{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function readPdpProductData() {
    if (window.HnPdpCart && typeof window.HnPdpCart.readProductData === 'function') {
      return window.HnPdpCart.readProductData();
    }
    var el = document.querySelector('[data-hn-pdp-product-data]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function writePdpProductData(productData) {
    var el = document.querySelector('[data-hn-pdp-product-data]');
    if (!el || !productData) return;
    el.textContent = JSON.stringify(productData);
  }

  function applyCartQuantitiesToProductData(cart) {
    var productData = readPdpProductData();
    if (!productData || !Array.isArray(productData.variants) || !cart || !Array.isArray(cart.items)) return false;

    var qtyByVariant = {};
    cart.items.forEach(function (item) {
      var id = parseInt(item.variant_id || item.id, 10) || 0;
      if (!id) return;
      qtyByVariant[id] = (qtyByVariant[id] || 0) + (parseInt(item.quantity, 10) || 0);
    });

    productData.variants.forEach(function (variant) {
      var id = parseInt(variant.id, 10) || 0;
      variant.cart_quantity = qtyByVariant[id] || 0;
    });
    writePdpProductData(productData);
    return true;
  }

  var cartQuantityRefreshBound = false;
  var cartQuantityRefreshTimer = null;
  function initCartQuantityRefresh() {
    if (cartQuantityRefreshBound) return;
    cartQuantityRefreshBound = true;

    function refresh(cart) {
      if (applyCartQuantitiesToProductData(cart)) {
        updateStandardOrderPricing();
        document.dispatchEvent(new CustomEvent('hn:pdp:inventory-refresh'));
        return;
      }

      clearTimeout(cartQuantityRefreshTimer);
      cartQuantityRefreshTimer = setTimeout(function () {
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
          .then(function (resp) { return resp.ok ? resp.json() : null; })
          .then(function (freshCart) {
            if (!freshCart || !applyCartQuantitiesToProductData(freshCart)) return;
            updateStandardOrderPricing();
            document.dispatchEvent(new CustomEvent('hn:pdp:inventory-refresh'));
          })
          .catch(function () {});
      }, 250);
    }

    document.addEventListener('hn:cart:updated', function (event) {
      refresh(event && event.detail && event.detail.cart);
    });
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        refresh(event && event.cartData);
      });
    }
  }

  function findVariantById(productData, variantId) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    var id = parseInt(variantId, 10) || 0;
    if (!id) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (parseInt(productData.variants[i].id, 10) === id) return productData.variants[i];
    }
    return null;
  }

  function getSelectedVariant(productData) {
    var form = document.querySelector('[data-hn-pdp-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput ? findVariantById(productData, idInput.value) : null;
  }

  function variantCartQty(variant) {
    return Math.max(0, parseInt(variant && variant.cart_quantity, 10) || 0);
  }

  function productCartQty(productData) {
    if (!productData || !Array.isArray(productData.variants)) return 0;
    return productData.variants.reduce(function (sum, variant) {
      return sum + variantCartQty(variant);
    }, 0);
  }

  function variantQuantityRuleMax(variant) {
    if (!variant || !variant.quantity_rule || variant.quantity_rule.max == null) return null;
    var max = parseInt(variant.quantity_rule.max, 10);
    return isNaN(max) ? null : max;
  }

  function variantTracksFiniteInventory(variant) {
    if (!variant) return false;
    return variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
  }

  function variantAddableInfo(variant, productData) {
    if (!variant) return { cap: 0, reason: 'unavailable', limit: MAX_PRODUCT_QTY };
    if (!variant.available) return { cap: 0, reason: 'sold_out', limit: MAX_PRODUCT_QTY };

    var inCart = variantCartQty(variant);
    var productInCart = productCartQty(productData || readPdpProductData());
    var limit = MAX_PRODUCT_QTY;
    var cap = Math.max(0, limit - productInCart);
    var reason = cap <= 0 ? 'max' : 'max';
    var ruleMax = variantQuantityRuleMax(variant);
    if (ruleMax != null) {
      if (ruleMax < limit) limit = ruleMax;
      var ruleRemaining = Math.max(0, ruleMax - inCart);
      if (ruleRemaining < cap) {
        cap = ruleRemaining;
        reason = cap <= 0 ? 'max' : 'rule';
      }
    }

    if (variantTracksFiniteInventory(variant)) {
      var stock = Math.max(0, parseInt(variant.inventory_quantity, 10) || 0);
      var stockRemaining = Math.max(0, stock - inCart);
      if (stockRemaining < cap) {
        cap = stockRemaining;
        reason = cap <= 0 && stock > 0 ? 'max' : (cap <= 0 ? 'sold_out' : 'stock');
      }
    }
    if (reason === 'stock') limit = Math.min(limit, inCart + cap);
    return { cap: cap, reason: reason, limit: limit };
  }

  function stockMessage(info) {
    if (!info || info.cap > 0) {
      if (info && info.reason === 'stock' && info.cap <= 5) {
        return 'Only ' + info.cap + ' left.';
      }
      return '';
    }
    if (info.reason === 'max' || info.reason === 'rule') return 'Max ' + (info.limit || MAX_PRODUCT_QTY) + ' per order.';
    return 'Out of stock.';
  }

  function setStockNote(note, message, isError) {
    if (!note) return;
    note.textContent = message || '';
    note.classList.toggle('is-error', !!isError);
  }

  function applyQtyCap(cap) {
    document.querySelectorAll('[data-hn-pdp-qty]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-hn-pdp-qty-input]');
      var valueEl = stepper.querySelector('[data-hn-pdp-qty-value]');
      var decBtn = stepper.querySelector('[data-hn-pdp-qty-step="dec"]');
      var incBtn = stepper.querySelector('[data-hn-pdp-qty-step="inc"]');
      if (!input || !valueEl) return;

      var max = parseInt(cap, 10);
      if (isNaN(max)) max = MAX_PRODUCT_QTY;
      input.setAttribute('max', String(max));
      input.dataset.hnPdpQtyMax = String(max);

      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (max > 0 && v > max) v = max;
      input.value = String(v);
      valueEl.textContent = String(v);
      if (decBtn) decBtn.disabled = max <= 0 || v <= 1;
      if (incBtn) incBtn.disabled = max <= 0 || v >= max;
    });
  }

  function ensureAtcPriceLabel(button, variant) {
    if (!button) return;
    var label = button.querySelector('[data-hn-pdp-atc-label]');
    if (!label) return;
    var priceSpan = label.querySelector('[data-hn-pdp-atc-price][data-hn-pdp-unit-price]');
    if (!priceSpan) {
      var defaultLabel = button.getAttribute('data-hn-pdp-atc-default-label') || 'Add to Cart';
      label.textContent = '';

      var text = document.createElement('span');
      text.setAttribute('data-hn-pdp-atc-text', '');
      text.textContent = defaultLabel;
      label.appendChild(text);

      var compare = document.createElement('s');
      compare.className = 'hn-pdp__atc-compare';
      compare.setAttribute('data-hn-pdp-atc-compare', '');
      label.appendChild(compare);

      priceSpan = document.createElement('span');
      priceSpan.className = 'hn-pdp__atc-price';
      priceSpan.setAttribute('data-hn-pdp-atc-price', '');
      priceSpan.setAttribute('data-hn-pdp-unit-price', '');
      label.appendChild(priceSpan);
    }
    if (variant && priceSpan) {
      var unitPrice = parseInt(variant.price, 10) || 0;
      var unitCompare = parseInt(variant.compare_at_price, 10) || 0;
      priceSpan.setAttribute('data-hn-pdp-unit-price', String(unitPrice));
      var compareSpan = label.querySelector('[data-hn-pdp-atc-compare]');
      if (compareSpan) compareSpan.setAttribute('data-hn-pdp-unit-compare', String(Math.max(unitCompare, unitPrice)));
    }
  }

  function updateStandardStockState(variant, productData) {
    var form = document.querySelector('[data-hn-pdp-product-form]');
    if (!form || !variant) return;
    var button = form.querySelector('button[name="add"]');
    var note = document.querySelector('[data-hn-pdp-stock-note]');
    var standaloneNote = document.querySelector('[data-hn-pdp-stock-note-standalone]');
    var info = variantAddableInfo(variant, productData);
    var message = stockMessage(info);
    var blocked = info.cap <= 0;
    var qtyWrap = document.querySelector('[data-hn-pdp-qty-wrap]');
    var hideQty = blocked && info.reason !== 'max' && info.reason !== 'rule';

    applyQtyCap(info.cap);
    if (qtyWrap) qtyWrap.hidden = hideQty;
    setStockNote(note, hideQty ? '' : message, blocked);
    setStockNote(standaloneNote, hideQty ? message : '', blocked);

    if (!button) return;
    if (blocked) {
      button.disabled = true;
      var label = button.querySelector('[data-hn-pdp-atc-label]');
      if (label) label.textContent = info.reason === 'max' || info.reason === 'rule' ? 'Max Reached' : 'Sold Out';
      return;
    }

    button.disabled = false;
    ensureAtcPriceLabel(button, variant);
  }

  function selectedVariantCounts(tier) {
    var counts = {};
    if (!tier) return counts;
    tier.querySelectorAll('[data-hn-pdp-bundle-slot]').forEach(function (slot) {
      var id = parseInt(slot.value, 10);
      if (!id) return;
      counts[id] = (counts[id] || 0) + 1;
    });
    return counts;
  }

  function bundleInventoryMessage(tier, productData) {
    var counts = selectedVariantCounts(tier);
    var total = 0;
    var productRemaining = Math.max(0, MAX_PRODUCT_QTY - productCartQty(productData));
    for (var id in counts) {
      if (!Object.prototype.hasOwnProperty.call(counts, id)) continue;
      total += counts[id];
    }
    if (total > productRemaining) {
      if (productRemaining <= 0) return 'Max ' + MAX_PRODUCT_QTY + ' per order.';
      return 'Only ' + productRemaining + ' more can be added.';
    }
    for (id in counts) {
      if (!Object.prototype.hasOwnProperty.call(counts, id)) continue;
      var variant = findVariantById(productData, id);
      var info = variantAddableInfo(variant, productData);
      if (counts[id] > info.cap) {
        if (info.cap <= 0) return stockMessage(info) || 'This option is sold out.';
        return 'Only ' + info.cap + ' left for this option.';
      }
    }
    return null;
  }

  function orderDiscountPct() {
    if (window.HnPdpCart && typeof window.HnPdpCart.readActiveOrderPct === 'function') {
      return window.HnPdpCart.readActiveOrderPct();
    }
    return 0;
  }

  function finalAfterOrder(rawCents, pct) {
    if (window.HnPdpCart && typeof window.HnPdpCart.lineFinalAfterOrder === 'function') {
      return window.HnPdpCart.lineFinalAfterOrder(rawCents, pct);
    }
    var p = parseInt(pct, 10) || 0;
    return p > 0 ? rawCents - Math.floor(rawCents * p / 100) : rawCents;
  }

  function updateStandardOrderPricing() {
    var form = document.querySelector('[data-hn-pdp-product-form]');
    if (!form) return;

    var productData = readPdpProductData();
    var variant = getSelectedVariant(productData);
    if (!variant) {
      updateAtcPrice();
      return;
    }

    var unit = parseInt(variant.price, 10) || 0;
    var compareAt = parseInt(variant.compare_at_price, 10) || 0;
    var pct = orderDiscountPct();
    var effective = finalAfterOrder(unit, pct);
    var regular = compareAt > unit ? compareAt : unit;
    var savings = regular - effective;
    var savingsPct = regular > 0 && savings > 0 ? Math.round((savings * 100) / regular) : 0;

    var priceBlock = document.querySelector('.hn-pdp__price');
    if (priceBlock) {
      var html = '<span class="hn-pdp__price-current">' + formatMoney(effective) + '</span>';
      if (regular > effective) {
        html += '<s class="hn-pdp__price-compare">' + formatMoney(regular) + '</s>';
        html += '<span class="hn-pdp__price-badge">Save ' + savingsPct + '%</span>';
      }
      priceBlock.innerHTML = html;
    }

    var sticky = document.querySelector('[data-hn-pdp-sticky-price]');
    if (sticky) sticky.textContent = formatMoney(effective);

    updateStandardStockState(variant, productData);
    updateAtcPrice();
  }

  async function bundleAddToCart(items, button, analyticsContext) {
    if (button) {
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
    }

    /* Open the drawer the instant the user clicks so the slide-in
       animation overlaps with the fetch round-trip. Without this
       the user stares at a static page for ~600ms before anything
       visible happens. Ghost-row insertion is intentionally
       skipped for bundles â€” credibly faking N rows with shared
       bundle_id properties is disproportionate complexity for the
       marginal win. The cart-drawer section swap a few hundred ms
       later still feels snappy because the drawer is already open. */
    if (window.HnAnalytics && typeof window.HnAnalytics.setNextCartDrawerOpenReason === 'function') {
      window.HnAnalytics.setNextCartDrawerOpenReason('pdp_bundle');
    }
    if (window.HnPdpCart && typeof window.HnPdpCart.openDrawerOptimistic === 'function') {
      window.HnPdpCart.openDrawerOptimistic(button);
    }

    /* Full-fidelity optimistic bundle row: paint the combined /
       member bundle card into the open drawer on the click frame so
       the add feels instant (matching the single-product + upsell
       ATC paths) instead of staring at a loading drawer until the
       server responds. insertBundleGhost returns null when it can't
       build a faithful ghost (product already in cart â†’ server will
       regroup, sub-tier mix, or product data missing); in that case
       we keep the prior open-and-wait behavior. Rolled back in the
       catch on failure; the success-path section swap below replaces
       it with the canonical card. */
    var bundleGhost = null;
    var footerRevert = null;
    if (window.HnPdpCart && typeof window.HnPdpCart.insertBundleGhost === 'function') {
      bundleGhost = window.HnPdpCart.insertBundleGhost(items);
    }

    /* Move the footer Estimated Total + Total Savings with the add, in
       lockstep with the row. insertBundleGhost returns the bundle's
       per-line final (tier floored on price, order code floored on
       discount) + retail; the bundle row was already built with that
       same final, so applyLineAddToFooter just bumps the footer to
       match. Skipped when the ghost bailed (null) â€” e.g. the product
       was already in the cart and the server will regroup. Reverted in
       the catch; the success swap reconciles. */
    if (bundleGhost && typeof bundleGhost.footerFinalDelta === 'number' &&
        window.HnCart && typeof window.HnCart.applyLineAddToFooter === 'function') {
      footerRevert = window.HnCart.applyLineAddToFooter(
        bundleGhost.footerFinalDelta,
        bundleGhost.footerRetailDelta
      );
    }

    /* Optimistically bump the header cart count + free-shipping
       bar by the totals across all bundle items. Count = sum
       of quantities; shipping = sum of (variant.price * qty)
       resolved from the product-data block. Captured for
       rollback in the catch block. */
    var bundleCountDelta = 0;
    var bundleShipDelta = 0;
    if (window.HnPdpCart && typeof window.HnPdpCart.bumpCountBadge === 'function') {
      var totalQty = 0;
      var totalCents = 0;
      var bundleProductData =
        typeof window.HnPdpCart.readProductData === 'function'
          ? window.HnPdpCart.readProductData()
          : null;

      for (var qi = 0; qi < items.length; qi++) {
        var itemQty = parseInt(items[qi].quantity, 10) || 0;
        totalQty += itemQty;
        if (bundleProductData && bundleProductData.variants) {
          for (var vi = 0; vi < bundleProductData.variants.length; vi++) {
            if (bundleProductData.variants[vi].id === items[qi].id) {
              var vp = parseInt(bundleProductData.variants[vi].price, 10) || 0;
              totalCents += vp * itemQty;
              break;
            }
          }
        }
      }

      bundleCountDelta = window.HnPdpCart.bumpCountBadge(totalQty);
      if (typeof window.HnPdpCart.bumpShippingBar === 'function') {
        bundleShipDelta = window.HnPdpCart.bumpShippingBar(totalCents);
      }
    }

    try {
      /* Shopify's /cart/add.js supports a `sections` parameter that
         returns rendered HTML for the requested sections in the
         response â€” saves a round trip to refresh the cart drawer. */
      var addBody = {
        items: items,
        sections: 'cart-drawer,cart-icon-bubble,cart-notification',
        sections_url: window.location.pathname
      };

      var addResp = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(addBody)
      });
      var result = await addResp.json();
      if (!addResp.ok) {
        throw new Error(result.description || result.message || 'Add to cart failed');
      }

      /* Swap in any returned section HTML.

         Mirror Dawn's CartDrawer.renderContents pattern instead of
         doing a broad `cart-drawer` element innerHTML swap. The
         broad swap (previous version) destroyed #CartDrawer-Overlay
         and never updated `is-empty` on the live <cart-drawer>,
         which triggered `cart-drawer.is-empty .drawer__header
         { display: none }` and produced a blank drawer panel on
         first add. */
      var liveDrawer = document.querySelector('cart-drawer');
      var sections = result.sections || {};

      if (sections['cart-drawer']) {
        var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshInner = drawerDoc.querySelector('#CartDrawer');
        var liveInner = document.querySelector('#CartDrawer');
        if (freshInner && liveInner) {
          liveInner.innerHTML = freshInner.innerHTML;
        }
        /* Toggle is-empty on the live <cart-drawer> using the
           freshly-rendered drawer as source of truth. /cart/add.js
           doesn't return a top-level `item_count` (it returns the
           added line items only), so trying to read it from
           `result` quietly never fires the toggle â€” which is what
           left empty â†’ non-empty stuck on `is-empty` and caused
           `cart-drawer.is-empty .drawer__header { display: none }`
           to hide the header on every first add. */
        var freshDrawer = drawerDoc.querySelector('cart-drawer');
        if (liveDrawer && freshDrawer) {
          liveDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
        /* Rebind the overlay click â€” the new #CartDrawer-Overlay
           is a freshly parsed node and inherits nothing from the
           old one's listener. */
        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay && liveDrawer && typeof liveDrawer.close === 'function') {
          overlay.addEventListener('click', liveDrawer.close.bind(liveDrawer));
        }
      }

      if (sections['cart-icon-bubble']) {
        var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = bubbleDoc.querySelector('.shopify-section');
        var liveBubble = document.querySelector('#cart-icon-bubble');
        if (freshBubble && liveBubble) {
          liveBubble.innerHTML = freshBubble.innerHTML;
        }
      }

      if (sections['cart-notification'] && document.querySelector('cart-notification')) {
        var notifDoc = new DOMParser().parseFromString(sections['cart-notification'], 'text/html');
        var freshNotif = notifDoc.querySelector('cart-notification');
        var liveNotif = document.querySelector('cart-notification');
        if (freshNotif && liveNotif) {
          liveNotif.innerHTML = freshNotif.innerHTML;
        }
      }

      if (analyticsContext && analyticsContext.ecommerce) {
        if (window.HnAnalytics && typeof window.HnAnalytics.pushEcommerce === 'function') {
          window.HnAnalytics.pushEcommerce('hn_add_to_cart', analyticsContext.ecommerce, analyticsContext.params || {});
        } else if (window.HN_TRACKING_DISABLED !== true && window.HnTrackingDisabled !== true) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push(Object.assign({
            event: 'hn_add_to_cart',
            ecommerce: analyticsContext.ecommerce
          }, analyticsContext.params || {}));

          /* Fallback bypasses hn-analytics.js (which hosts the telemetry
             mirror), so mirror explicitly to keep both pipelines seeing
             the same events. */
          if (window.HnTelemetry && typeof window.HnTelemetry.mirror === 'function') {
            try {
              window.HnTelemetry.mirror('hn_add_to_cart', Object.assign({
                ecommerce: analyticsContext.ecommerce
              }, analyticsContext.params || {}));
            } catch (e) {}
          }
        }
      }

      /* Open the cart drawer if the theme has one */
      if (liveDrawer && typeof liveDrawer.open === 'function') {
        liveDrawer.open(button);
      } else if (liveDrawer && typeof liveDrawer.classList !== 'undefined') {
        liveDrawer.classList.add('active', 'is-open');
        liveDrawer.removeAttribute('hidden');
      }

      /* Notify the rest of the theme (cart icon bubble counters, etc.).
         PUB_SUB_EVENTS is a bare const from constants.js, never a window
         property, so only the bare reference resolves. */
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof window.publish === 'function') {
        window.publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'hn-pdp-bundle',
          productVariantId: items[0] && items[0].id,
          cartData: result
        });
      }
    } catch (err) {
      console.error('[hn-pdp-bundle] cart add failed:', err);
      /* Roll back optimistic count + shipping bar so the
         header badge AND the shipping progress go back to the
         pre-click state. Drawer's is-loading class is cleared
         by the optimistic module's safety timeout / cartError
         subscription. */
      if (bundleCountDelta && window.HnPdpCart && typeof window.HnPdpCart.revertCountBadge === 'function') {
        window.HnPdpCart.revertCountBadge(bundleCountDelta);
      }
      if (bundleShipDelta && window.HnPdpCart && typeof window.HnPdpCart.revertShippingBar === 'function') {
        window.HnPdpCart.revertShippingBar(bundleShipDelta);
      }
      /* Pull the optimistic bundle card back out so the drawer
         returns to its pre-click state on failure. */
      if (bundleGhost && window.HnPdpCart && typeof window.HnPdpCart.revertGhostRow === 'function') {
        window.HnPdpCart.revertGhostRow(bundleGhost.row, bundleGhost.revert);
      }
      /* Undo the optimistic footer move too. */
      if (footerRevert && window.HnCart && typeof window.HnCart.revertLineAddToFooter === 'function') {
        window.HnCart.revertLineAddToFooter(footerRevert);
      }
      window.alert(err.message || 'Could not add to cart. Please try again.');
    } finally {
      if (button) {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
      }
    }
  }

  /* ---------- ATC button price (unit x qty) ----------
     The ATC button shows the line price. The unit price (cents) rides on
     the price span as data-hn-pdp-unit-price â€” re-rendered per variant by
     the server and restored after a variant change by initVariantPriceSync
     â€” so we just multiply it by the current qty. Only the standard ATC
     span carries the attr; the bundle ATC (managed by initBundles) is left
     untouched. */
  function getPdpQty() {
    var qtyInput = document.querySelector('[data-hn-pdp-qty-input]');
    return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function updateAtcPrice() {
    var qty = getPdpQty();
    var hasPredict = window.HnPdpCart && typeof window.HnPdpCart.predictLineCents === 'function';
    document.querySelectorAll('[data-hn-pdp-atc-price][data-hn-pdp-unit-price]').forEach(function (el) {
      var unit = parseInt(el.getAttribute('data-hn-pdp-unit-price'), 10);
      if (isNaN(unit)) return;
      /* Show the LANDED price (unit x qty after the active cart-level order
         code, floor-the-discount) so the button matches the cart, not the
         pre-discount total. Falls back to unit x qty if the optimistic
         layer isn't present. */
      var cents = hasPredict ? window.HnPdpCart.predictLineCents(unit, qty) : unit * qty;
      el.textContent = formatMoney(cents);
      /* Struck regular total beside it, only when the shopper saves. */
      var compareEl = el.parentNode ? el.parentNode.querySelector('[data-hn-pdp-atc-compare][data-hn-pdp-unit-compare]') : null;
      if (compareEl) {
        var regular = (parseInt(compareEl.getAttribute('data-hn-pdp-unit-compare'), 10) || 0) * qty;
        compareEl.textContent = regular > cents ? formatMoney(regular) : '';
      }
    });
  }

  /* ---------- Quantity stepper (standard mode) ----------
     Custom +/- control matching the cart UX: a non-editable value span +
     a hidden input[name=quantity] for the product form. Min 1; the minus
     button greys out (disabled) at 1. Not Dawn's <quantity-input> â€” see
     the markup comment in hn-pdp-main.liquid for why. */
  function initQtyStepper() {
    document.querySelectorAll('[data-hn-pdp-qty]').forEach(function (stepper) {
      if (stepper.dataset.hnPdpQtyReady === '1') return;
      stepper.dataset.hnPdpQtyReady = '1';

      var input = stepper.querySelector('[data-hn-pdp-qty-input]');
      var valueEl = stepper.querySelector('[data-hn-pdp-qty-value]');
      var decBtn = stepper.querySelector('[data-hn-pdp-qty-step="dec"]');
      var incBtn = stepper.querySelector('[data-hn-pdp-qty-step="inc"]');
      if (!input || !valueEl) return;

      function sync() {
        var max = parseInt(input.dataset.hnPdpQtyMax || input.getAttribute('max'), 10);
        if (isNaN(max)) max = MAX_PRODUCT_QTY;
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (max > 0 && v > max) v = max;
        input.value = String(v);
        valueEl.textContent = String(v);
        if (decBtn) decBtn.disabled = max <= 0 || v <= 1;
        if (incBtn) incBtn.disabled = max <= 0 || v >= max;
      }

      stepper.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hn-pdp-qty-step]');
        if (!btn || !stepper.contains(btn)) return;
        e.preventDefault();
        if (btn.disabled) return;
        var max = parseInt(input.dataset.hnPdpQtyMax || input.getAttribute('max'), 10);
        if (isNaN(max)) max = MAX_PRODUCT_QTY;
        if (max <= 0) return;
        var v = parseInt(input.value, 10) || 1;
        v += btn.getAttribute('data-hn-pdp-qty-step') === 'inc' ? 1 : -1;
        if (v < 1) v = 1;
        if (v > max) v = max;
        input.value = String(v);
        sync();
        /* Recompute the ATC button price on the click (NOT on the initial
           sync below) so the server-rendered discounted price stands on
           first paint â€” no flash. */
        updateAtcPrice();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      sync();
    });
  }

  /* ---------- Init ---------- */

  function init() {
    document.querySelectorAll('[data-hn-pdp-gallery]').forEach(initGallery);
    initVariantSync();
    initVariantPriceSync();
    initCtaScroll();
    initQtyStepper();
    updateStandardOrderPricing();
    initCartQuantityRefresh();
    initStickyBar();
    initRatingScroll();
    initBundles();
  }

  window.HnPdpMain = window.HnPdpMain || {};
  window.HnPdpMain.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify section reloads (theme editor) â€” re-init when our section is
     re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hn-pdp]')) {
      init();
    }
  });
})();
